import React, { PureComponent } from 'react'
import styled from 'styled-components'
import getFont from '../../../helpers/fonts/fonts'
import getPalette, { IPalette } from '../../../helpers/colors/colors'
import iconClassic from '../../../assets/icons/settings/classic.jpg'
import iconSpace from '../../../assets/icons/settings/space.jpg'
import iconHalloween from '../../../assets/icons/settings/halloween.jpg'
import iconHoliday from '../../../assets/icons/settings/holiday.jpg'
import iconValentines from '../../../assets/icons/settings/valentines.jpg'
import iconUnderwater from '../../../assets/icons/settings/underwater.jpg'
import iconCarnival from '../../../assets/icons/settings/carnival.jpg'
import iconSports from '../../../assets/icons/settings/sports.jpg'
import iconJungle from '../../../assets/icons/settings/jungle.jpg'
import iconBeach from '../../../assets/icons/settings/beach.jpg'
import checkmark from '../../../assets/icons/checkmark.svg'
import settingsTypes from '../../../helpers/enums/settings'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './SettingsCarousel.css'

const colors: IPalette = getPalette()

const Wrapper = styled.div`
	width: 100%;
	line-height: 0;
	padding-top: 16px;
	text-align: left;
`

const Title = styled.div`
	color: ${colors.grayLight2};
	display: inline-block;
	font-family: ${getFont('primaryMedium')};
	font-size: 14px;
	line-height: 16px;
	vertical-align: top;
	width: 100%;
	text-align: center;
	margin-bottom: 8px;
`

const Thumb = styled.li`
	cursor: pointer;
	display: flex;
	position: relative;
	vertical-align: top;
	margin: 0;
	flex-direction: column;
	justify-content: space-between;

	@media (min-width: ${600}px) {
		margin-bottom: 3px;
	}
`

const ThumbImageContainer = styled.div`
	border: 1px solid rgba(0, 0, 0, 0);
	text-align: left;
	position: relative;
	&.selected {
		border: 3px solid ${colors.blue};
		padding: 5px;
	}
`

const ThumbNewLabel = styled.div`
	background-color: ${colors.yellow};
	color: ${colors.white};
	font-family: ${getFont('primaryMedium')};
	font-size: 15px;
	line-height: 12px;
	padding: 5px 4px 3px;
	position: absolute;
	top: 11px;
	right: 8px;
`

const ThumbImage = styled.img`
	width: 100%;
	height: 100%;
	max-width: 100%;
	max-height: 100%;
	display: block;
`

const ThumbLabel = styled.div`
	color: ${colors.grayBlue};
	font-family: ${getFont('primaryMedium')};
	font-size: 16px;
	line-height: 16px;
	padding-top: 2px;
	margin-top: 8px;
	text-align: center;
`

const ThumbCheckmark = styled.img`
	width: 28px;
	height: 28px;
	border-radius: 14px;
	border: 4px solid ${colors.white};
	background-color: ${colors.blue};
	padding: 1px;
	position: absolute;
	top: 10px;
	left: 10px;
`

interface IThumb {
	hasNewLabel: boolean
	id: number
	label: string
	selected: boolean
	icon: any
}

interface ICarouselProps {
	onChange: (value: number) => void
	value: number
	values: number[]
}

interface ICarouselState {
	thumbs: IThumb[]
}

const carouselSettings = {
	dots: false,
	infinite: false,
	speed: 500,
	swipeToSlide: false,
	slidesToShow: 3,
	slidesToScroll: 3,

	responsive: [
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				swipeToSlide: true,
			},
		},
	],
}

class SettingsCarousel extends PureComponent<ICarouselProps, ICarouselState> {
	constructor(props: ICarouselProps) {
		super(props)

		const thumbs = [
			{
				id: settingsTypes.SETTING_SKIN_DEFAULT,
				label: 'Himalaya',
				icon: iconClassic,
				hasNewLabel: false,
			},
			{
				id: settingsTypes.SETTING_SKIN_BEACH,
				label: 'Beach',
				icon: iconBeach,
				hasNewLabel: true,
			},
			{
				id: settingsTypes.SETTING_SKIN_CARNIVAL,
				label: 'Carnival',
				icon: iconCarnival,
				hasNewLabel: true,
			},
			{
				id: settingsTypes.SETTING_SKIN_JUNGLE,
				label: 'Jungle',
				icon: iconJungle,
				hasNewLabel: true,
			},
			{
				id: settingsTypes.SETTING_SKIN_SPORTS,
				label: 'Sports',
				icon: iconSports,
				hasNewLabel: true,
			},
			{
				id: settingsTypes.SETTING_SKIN_SPACE,
				label: 'Space',
				icon: iconSpace,
				hasNewLabel: false,
			},
			{
				id: settingsTypes.SETTING_SKIN_HALLOWEEN,
				label: 'Halloween',
				icon: iconHalloween,
				hasNewLabel: false,
			},
			{
				id: settingsTypes.SETTING_SKIN_HOLIDAY,
				label: 'Happy Holidays!',
				icon: iconHoliday,
				hasNewLabel: false,
			},
			{
				id: settingsTypes.SETTING_SKIN_VALENTINES,
				label: 'Valentine’s Day',
				icon: iconValentines,
				hasNewLabel: false,
			},
			{
				id: settingsTypes.SETTING_SKIN_UNDERWATER,
				label: 'Underwater',
				icon: iconUnderwater,
				hasNewLabel: false,
			},
			{
				id: settingsTypes.SETTING_SKIN_APRIL_FOOLS,
				label: 'Himalaya',
				icon: iconClassic,
				hasNewLabel: false,
			},
		]
			.filter((thumb) => props.values.includes(thumb.id))
			.map((thumb) => ({
				...thumb,
				selected: thumb.id === props.value,
			}))
		this.state = {
			thumbs,
		}
	}

	onThumbSelect = (selectedThumb: IThumb) => {
		const thumbs = this.state.thumbs.map((thumb) => {
			if (selectedThumb === thumb && !selectedThumb.selected) {
				return {
					...thumb,
					selected: true,
				}
			} else if (selectedThumb !== thumb && thumb.selected) {
				return {
					...thumb,
					selected: false,
				}
			} else {
				return thumb
			}
		})
		this.setState({
			thumbs,
		})
		this.props.onChange(selectedThumb.id)
	}

	buildThumbs = (thumbs: IThumb[]) => {
		return thumbs.map((thumb) => (
			<Thumb key={thumb.id} onClick={() => this.onThumbSelect(thumb)}>
				<ThumbImageContainer className={thumb.selected ? 'selected' : ''}>
					<ThumbImage src={thumb.icon}></ThumbImage>
					{thumb.hasNewLabel && <ThumbNewLabel>New!</ThumbNewLabel>}
				</ThumbImageContainer>
				<ThumbLabel>{thumb.label}</ThumbLabel>
				{thumb.selected && <ThumbCheckmark src={checkmark} />}
			</Thumb>
		))
	}

	render() {
		return (
			<Wrapper id='themes-carousel'>
				<Title>Select a Time to Climb Theme</Title>

				<Slider {...carouselSettings}>{this.buildThumbs(this.state.thumbs)}</Slider>
			</Wrapper>
		)
	}
}

export default SettingsCarousel
